import { useCallback } from "react";

import { ConversationMessage } from "../../../../model/integration/dto/meta/MetaConversationMessage";
import { integrationSliceSelectors } from "../../../../redux/integration/integration.selector";
import { integrationActions } from "../../../../redux/integration/integration.slice";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { userSliceSelectors } from "../../../../redux/user/user.selector";
import { AtiraToast } from "../../../../utils/AtiraToast";

export const useWAMessageReaction = (message: ConversationMessage) => {
  const dispatch = useAppDispatch();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const integration = useAppSelector(
    integrationSliceSelectors.selectWhatsAppMetaIntegration,
  );

  const ours = integration?.config?.phoneNumberId || "";
  const ownReaction = message.reactions?.find(
    (reaction) => reaction.from === ours,
  );

  const react = useCallback(
    async (emoji: string) => {
      const next = ownReaction?.emoji === emoji ? "" : emoji;

      const others = (message.reactions || []).filter(
        (reaction) => reaction.from !== ours,
      );

      // Applied locally first: the round trip runs all the way out to Meta.
      dispatch(
        integrationActions.metaUpdateMessage({
          ...message,
          reactions: next
            ? [
                ...others,
                {
                  emoji: next,
                  from: ours,
                  timestamp: String(Math.floor(Date.now() / 1000)),
                },
              ]
            : others,
        }),
      );

      try {
        await dispatch(
          integrationActions.reactToWhatsappMetaMessage({
            userId,
            integrationId: integration!._id,
            conversationId: message.conversationId,
            messageId: message._id,
            emoji: next,
          }),
        ).unwrap();
      } catch (e) {
        dispatch(integrationActions.metaUpdateMessage(message));
        console.log(e);
        AtiraToast.apiError(e);
      }
    },
    [dispatch, integration, message, ownReaction?.emoji, ours, userId],
  );

  const removeOwnReaction = useCallback(() => {
    if (ownReaction) {
      react(ownReaction.emoji);
    }
  }, [ownReaction, react]);

  return { ownReaction, ours, react, removeOwnReaction };
};
